import { Injectable } from '@angular/core';
import { ApiService, IInvoiceInfo, IPaymentIntent } from '@cakeiteasy/web-utils';
import { Observable } from 'rxjs';
import { IPaymentInfo, IWebhookUrls } from '../../payment';

export interface IPaymentPayload extends IWebhookUrls, IPaymentInfo {
  layout?: string;
}

@Injectable({ providedIn: 'root' })
export class PaymentApiService {
  constructor(private _api: ApiService) {
  }

  public createInvoice(invoiceInfo: IInvoiceInfo, customerInfo: IPaymentInfo): Observable<{ sid: string }> {
    const model = this._makeInvoiceModel(invoiceInfo, customerInfo);
    return this._createPayment('invoice', model);
  }

  public createBamboraPayment(payload: IPaymentPayload) {
    return this._createPayment('bambora', payload);
  }

  public createDinteroPayment(payload: IPaymentPayload) {
    return this._createPayment('dintero', payload);
  }

  public createVippsPayment(payload: IPaymentPayload) {
    return this._createPayment('vipps', payload);
  }

  public createKlarnaPayment(payload: IPaymentPayload) {
    return this._createPayment('klarna', payload);
  }

  public createPayInStorePayment(payload: IPaymentPayload) {
    return this._createPayment('pay-in-store', payload);
  }

  public createGiftCardPayment(payload: IPaymentPayload) {
    return this._createPayment('giftcard', payload);
  }

  public createZeroPayment(payload: IPaymentPayload) {
    return this._createPayment('zero-payment', payload);
  }

  public createExtraPayment(orderId: number, intentId: number, paymentMethodName, payload: Partial<IPaymentPayload>) {
    return this._api
      .post('api.payments', 'extra', {
          orderId,
          paymentMethodName
        },
        payload,
        {
          params: { intentId }
        });
  }

  public getPaymentIntent(token: string): Observable<IPaymentIntent> {
    return this._api.get('api.payments', 'payment_intent_by_token', { token });
  }

  public cancelPayment(paymentId: number) {
    return this._api
      .get('api.payments', 'cancel_payment', { id: paymentId });
  }

  private _createPayment(name: string, payload: any) {
    return this._api
      .post('api.payments', 'byName', { name }, payload);
  }

  private _makeInvoiceModel(invoiceInfo: IInvoiceInfo, customerInfo: IPaymentInfo): any {
    return Object.assign({
      'invoiceCompanyId': invoiceInfo.company.id,
      'invoiceContactPersonName': customerInfo.userName,
      'invoiceOrgNumber': invoiceInfo.orgNumber,
      'invoiceOrgName': invoiceInfo.orgName,
      'invoiceFormat': invoiceInfo.format,
      'invoiceEmail': invoiceInfo.email,
    }, customerInfo, {
      'reference': invoiceInfo.reference
    });
  }
}
